module.exports = __webpack_public_path__ + "037cf5d45bc308afca2a50fe07b37cca.pdf";